import React, { useState, useEffect, useRef } from "react";
import Heading from "../Heading/Heading";
import "./Modal.scss";
export type width = "small" | "medium" | "large";
export type size = "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
export interface Props {
  children: any;
  buttonText?: any;
  width?: width;
  headerText?: any;
  customClass?: string;
  footerChildren?: any;
  headingType?: size;
  headingId?: string;
  mainBtnStyle?: React.CSSProperties;
  modalStyle?: React.CSSProperties;
  modalBodyStyle?: React.CSSProperties;
  modalFooterStyle?: React.CSSProperties;
  modalHeaderStyle?: React.CSSProperties;
  modalCloseStyle?: React.CSSProperties;
  modalContentStyle?: React.CSSProperties;

}
const Modal = ({
  children,
  buttonText = "Open Modal",
  width = "medium",
  headerText,
  customClass,
  footerChildren,
  headingType = "h2",
  headingId,
  mainBtnStyle,
  modalStyle,
  modalBodyStyle,
  modalFooterStyle,
  modalHeaderStyle,
  modalCloseStyle
}: Props) => {
  const [modal, setModal] = useState(false);
  const modalRef = useRef<any>(null);
  const modalOpen = () => {
    setModal(true);
  };
  const modalClose = () => {
    setModal(false);
    modalRef?.current?.focus();
  };
  useEffect(() => {
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        setModal(false);
        modalRef?.current?.focus();
      }
    });
  }, []);
  return (
    <>
      <button style={mainBtnStyle && mainBtnStyle} ref={modalRef} onClick={modalOpen}>
        {buttonText}
      </button>
      {modal && (
        <div
          className={`mfg-modal ${width}${customClass ? " " + customClass : ""}`}
          role="dialog"
          aria-labelledby={headerText}
          aria-modal="true" 
          style={modalStyle && modalStyle}
        >
          <div className="modalContent" >
            <button style={modalCloseStyle && modalCloseStyle} className="close" onClick={modalClose}>
              X
            </button>
            {headerText && (
              <Heading
                Type={headingType}
                HeadingId={headingId}
                HeadingClass="modelHeader"
                children={headerText}
                style={modalHeaderStyle && modalHeaderStyle}
              />
            )}
            <div className="modalBody" style={modalBodyStyle && modalBodyStyle}>{children}</div>
            {footerChildren && <div className="modalfooter" style={modalFooterStyle && modalFooterStyle}>{footerChildren}</div>}
          </div>
        </div>
      )}
    </>
  );
};

export default Modal;
